import { CkeditorConstants } from "../../src/utils";

const {
  WK_DISABLE_USER_SELECTION,
  helperAttributes: { SUBTEMPLATES_ALLOW, CONTENTEDITABLE },
  htmlElement: { DIV, PARAGRAPH, HTML_ASIDE, HEADER, ASIDE, LIST_ITEM },
  htmlAttributes: { CLASS },
  class: { section_content },
  htmlTagNames: { LI, P },
  HEADING_TAG_NAMES,
  HEADINGS,
} = CkeditorConstants;

export class SubtemplateShared {
  static isDomHeading(name) {
    return HEADING_TAG_NAMES.includes(name);
  }

  static isEditorHeading(name) {
    return HEADINGS.includes(name);
  }

  static isDomListItem(name) {
    return name.toLowerCase() === LI;
  }

  static isEditorListItem(name) {
    return name === LIST_ITEM;
  }

  static isDivElement(name) {
    return name.toLowerCase() === DIV;
  }

  /**
   * Checks if dom element is container element. Container elements are h1-h6, div, p and etc.
   * @param {HTMLElement} domElement Dom element
   * @returns {Boolean}
   */
  static isContainerDomElement(domElement) {
    const containerElementNames = [...HEADING_TAG_NAMES, DIV, HEADER, ASIDE, P];
    return containerElementNames.includes(domElement?.tagName?.toLowerCase()) && !(domElement?.getAttribute?.('class') === WK_DISABLE_USER_SELECTION);
  }

  /**
   * Checks if ckeditor element is container element. Container elements are heading1-heading6, div, paragraph and etc.
   * @param {Ckeditor.Node} editorElement Ckeditor element
   * @returns {Boolean}
   */
  static isContainerEditorElement(editorElement) {
    const containerElementNames = [...HEADINGS, DIV, PARAGRAPH, HTML_ASIDE, HEADER];
    return Boolean(editorElement.name) && containerElementNames.includes(editorElement.name);
  }

  /**
   * Return closest element with CSS class name
   * @param {Ckeditor.Node} editorElement Ckeditor element
   * @param {string} className CSS class name
   * @returns {Ckeditor.Element}
   */
  static closestByClass(editorElement, className) {
    if (editorElement.hasAttribute(CLASS) && element.getAttribute(CLASS).includes(className)) {
      return editorElement;
    } else {
      return editorElement.parent ? SubtemplateShared.closestByClass(editorElement.parent) : null;
    }
  }

  /**
   * Get closest ckeditor container element
   * @param {Ckeditor.Element} editorElement Ckeditor element
   * @returns {Ckeditor.Element}
   */
  static getEditorContainerElement(editorElement) {
    if (SubtemplateShared.isContainerEditorElement(editorElement)) {
        return editorElement;
    } else {
      return editorElement.parent ? SubtemplateShared.getEditorContainerElement(editorElement.parent) : editorElement;
    }
  }

  /**
   * Get closest DOM container element
   * @param {HTMLElement} domElement Dom Element
   * @returns {HTMLElement}
   */
  static getDomContainerElement(domElement) {
    if (domElement?.hasAttribute(CONTENTEDITABLE) && SubtemplateShared.isContainerDomElement(domElement)) {
      return domElement;
    } else {
      return domElement.parentElement ? SubtemplateShared.getDomContainerElement(domElement.parentElement) : null;
    }
  }

  /**
   * Returns ckeditor document selected node
   * @param {Ckeditor.Document} document Ckeditor document
   * @returns {Ckeditor.Node}
   */
  static getDocumentSelectedElement(document) {
    return document.selection?.anchor?.parent ? document.selection.anchor.parent : null;
  }

  /**
   * Get element with data-subtemplate-allow attribute. If element is heading returns heading element.
   * If element is list item returns closest element with data-subtemplate-allow attribute.
   * Otherwise check if current element or parent element has data-subtemplate-allow attribute
   * @param {HTMLElement} domElement Dom Element
   * @returns {HTMLElement}
   */
  static getSubtemplateAttrDomElement(domElement) {
    if (SubtemplateShared.isDomHeading(domElement.tagName)) {
      return domElement;
    }

    if (domElement?.parentElement && SubtemplateShared.isDomListItem(domElement.parentElement?.tagName)) {
      return domElement.parentElement.closest(`.${section_content}`)
    }

    if (domElement.hasAttribute(SUBTEMPLATES_ALLOW)) {
      return domElement;
    }

    if  (domElement.parentElement?.hasAttribute(SUBTEMPLATES_ALLOW)) {
      return domElement.parentElement;
    }

    return domElement;
  }

  /**
   * Get element with data-subtemplate-allow attribute. If element is heading returns heading element.
   * If element is list item returns closest element with data-subtemplate-allow attribute.
   * Otherwise check if current element or parent element has data-subtemplate-allow attribute
   * @param {Ckeditor.Element} editorElement
   * @returns {Ckeditor.Element} Ckeditor Element
   */
  static getSubtemplateAttrEditorElement(editorElement) {
    if (SubtemplateShared.isEditorHeading(editorElement.name)) {
      return editorElement;
    }

    if (editorElement?.parent && SubtemplateShared.isEditorListItem(editorElement.parent?.name)) {
      return closestByClass(domElement.parentElement, section_content) || editorElement;
    }

    if (editorElement?.hasAttribute(SUBTEMPLATES_ALLOW)) {
      return editorElement;
    }

    if (editorElement?.parent?.hasAttribute(SUBTEMPLATES_ALLOW)) {
      return editorElement.parent;
    }

    return editorElement;
  }
}
